import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import { ReactFC } from '../../types/react/ReactFC';
import { initiatePublicEnrollmentSession } from '../../apiCalls/publicEnrollment/publicEnrollmentApiCalls';
import { useMounted } from '../../hooks/components/useMounted';
import { LoadingBlock } from '../LoadingBlock';
import { publicEnrollmentSessionService } from '../../utils/PublicEnrollmentSessionService';

export const PublicEnrollmentLanding: ReactFC = () => {
    const { publicId } = useParams<{ publicId?: string}>();
    const isMounted = useMounted();

    const history = useHistory();

    const [ didPublicIdFailToValidate, setDidPublicIdFailToValidate ] = useState(false);

    useEffect(() => {
        async function makeRequest(publicId: string) {
            try {
                const response = await initiatePublicEnrollmentSession(publicId);
                if (isMounted.current) {

                    // ToDo: swap out id with different one!
                    publicEnrollmentSessionService._initializeSession({
                        enrollmentPackageId: response.enrollmentPackageId, 
                        employeePersonId: response.employeePersonId, 
                        publicKey: publicId
                    });
                    
                    history.push(`/packages/${response.enrollmentPackageId}/welcome`);
                }
            }
            catch {
                if (isMounted.current) {
                    setDidPublicIdFailToValidate(true);
                }
            }
        }

        if (publicId) {
            makeRequest(publicId);
        }
    }, [publicId]);


    if (publicId === undefined) {
        // Error state ToDo
        return <Alert variant="danger">Error</Alert>;
    }

    if (didPublicIdFailToValidate) {
        return (
            <Alert variant="danger">
                The link you accessed is not valid. 
                Please double check the link you are using. 
                If problems persist unexpectedly, please contact your system administrator.
            </Alert>
        );
    }

    return (
        <LoadingBlock />
    );
};